<template>
    <a :class="{ 'people-item': true }" href="javascript:{}">
        <div class="people-item-icon" @click="go_to_person(event_person.id)">
            <div>
                <div class="people-item-icon-container">
                    <span class="initials">
                        {{ event_person.first_name[0] }}
                        <span v-if="event_person.last_name">{{ event_person.last_name[0] }}</span></span
                    >
                </div>
            </div>
        </div>
        <div class="people-item-content" @click="go_to_person(event_person.id)">
            <div class="people-item-content-top">
                {{ event_person.first_name }} <span v-if="event_person.last_name">{{ event_person.last_name[0] }}</span>
            </div>
            <div class="people-item-content-bottom">
                <div class="people-item-socials">
                    <a v-if="event_person.phone" :href="'tel:' + event_person.phone">
                        <span class="icon-phone"></span>
                    </a>
                    <a href="javascript:{}" v-if="event_person.email" :href="'mailto:' + event_person.email">
                        <span class="icon-envelope"></span>
                    </a>
                    <a target="_blank" href="javascript:{}" v-if="event_person.facebook" :href="event_person.facebook">
                        <span class="icon-fb"></span>
                    </a>
                    <span
                        class="kids-count events-group-item-content"
                        v-if="event_person.kids_count && event_person.kids_count > 0"
                        >{{ event_person.kids_count }} kids</span
                    >
                </div>
            </div>
        </div>

        <div class="events-group-item--right">
            <div class="action">
                <div class="checkbox">
                    <input
                        :checked="guest_ids.includes(event_person.id)"
                        @change="check_changed(event_person.id, $event)"
                        :id="event_person.id"
                        type="checkbox"
                    />
                    <label :for="event_person.id"></label>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import router from "@/router";
import settings from "@/settings";
import vClickOutside from "v-click-outside";
import { mapActions, mapState } from "vuex";

export default {
    name: "people-group",
    props: ["event_person"],
    directives: {
        clickOutside: vClickOutside.directive
    },
    computed: {
        ...mapState("StoreEvent", ["guest_ids"])
    },
    data() {
        return {
            drop_shown: false,
            settings: settings
        };
    },
    methods: {
        ...mapActions("StoreEvent", ["change_person_event_status"]),
        change_event_attending_status(status) {
            this.away();
            let payload = {
                status: status,
                event_person: this.event_person
            };
            this.change_person_event_status(payload);
        },
        check_changed(person_id, event) {
            this.$emit("changed", { event, person_id });
        },
        open_drop() {
            this.drop_shown = !this.drop_shown;
        },
        go_to_person(person_id) {
            if (person_id) {
                router.push({ path: "/people/" + person_id });
            }
        },
        away() {
            if (this.drop_shown) {
                this.drop_shown = false;
            }
        }
    }
};
</script>

<style scoped>
.people-item-content {
    flex: 1;
}

.people-item {
    padding-right: 1.6rem;
}

.people-item-socials {
    display: flex;
}

.events-group-item--right {
    display: flex;
    flex-direction: column;
    margin-top: -0.6rem;
    justify-content: center;
}

.events-group-item-content {
    line-height: 1.6rem;
    align-items: flex-start;
}

.people-item-icon-container {
    opacity: 1;
}

.checkbox label::before,
.checkbox label::after {
    right: 0;
    left: initial;
}
</style>
